import { useEffect, useState } from 'react';
import { apiUrl, authHeaders } from './shell';

/** Images cannot attach the current session headers themselves. Resolve only
 * the private Chat path through the same authenticated fetch as other refs. */
export function usePrivateChatImage(source: string | undefined): string | undefined {
  const privatePath =
    source && /^\/api\/v1\/threads\/[\w-]+\/attachments\/[\w-]+\/content$/.test(source)
      ? source
      : undefined;
  const [resolved, setResolved] = useState<{ source: string; url: string } | null>(null);
  useEffect(() => {
    if (!privatePath) return;
    const controller = new AbortController();
    let url: string | undefined;
    void fetch(apiUrl(privatePath), {
      credentials: 'same-origin',
      headers: authHeaders(),
      signal: controller.signal,
    })
      .then(async (response) => {
        if (!response.ok) throw new Error('Private image unavailable');
        const blob = await response.blob();
        if (controller.signal.aborted || blob.size > 3.5 * 1024 * 1024) return;
        url = URL.createObjectURL(blob);
        setResolved({ source: privatePath, url });
      })
      .catch(() => {});
    return () => {
      controller.abort();
      if (url) URL.revokeObjectURL(url);
    };
  }, [privatePath]);
  return privatePath ? (resolved?.source === privatePath ? resolved.url : undefined) : source;
}
